const theme = {
  colors: {},
}

module.exports = theme
